import { useTestId } from '../../hooks/useTestId/useTestId';
import { Flag, FLAGS } from './countryFlags';
import { allCountries, countriesByAlpha3Code, CountryAlpha3Code, CountryName } from '@cmctechnology/webinvest-constants';
import styled from 'styled-components';

import { SIZES } from '../../fundamentals/sizes/sizes';
import { Avatar, IAvatarProps } from '../Avatar/Avatar';
import { useContext } from 'react';
import { EoraAssetsContext } from '../../themes/EoraThemeProvider';

export interface ICountryFlagProps extends IAvatarProps {
  code?: CountryAlpha3Code;
  alpha2?: Flag;
  name?: CountryName;
}

const DEFAULT_FLAG = FLAGS.AU;
const DEFAULT_FLAG_SIZE = SIZES.X_SMALL;

export const generateFlagUrl = ({ code, alpha2, name }: Pick<ICountryFlagProps, 'code' | 'name' | 'alpha2'>) => {
  const { baseAssetsUrl } = useContext(EoraAssetsContext);
  let countryCode: string | undefined = alpha2;

  if (code) {
    countryCode = countriesByAlpha3Code[code]?.alpha2 ?? countryCode;
  } else if (name) {
    countryCode = allCountries.find((country) => country.name === name)?.alpha2 ?? countryCode;
  }

  return {
    img: `${baseAssetsUrl}/images/f/${countryCode}.svg`,
    countryCode
  };
};

export const CountryFlag = styled(Avatar).attrs<ICountryFlagProps>(({ code, size, alpha2, name, onClick, ...rest }) => {
  const { img, countryCode = DEFAULT_FLAG } = generateFlagUrl({ code, alpha2, name });

  const { generateTestId } = useTestId(rest, `CountryFlag${countryCode.toUpperCase()}`);
  return {
    img: img,
    size: size ?? DEFAULT_FLAG_SIZE,
    border: true,
    ...generateTestId()
  };
})<ICountryFlagProps>``;
